@if (absencePrefill?.emailContent) {
  <p-panel header="E-Mail-Inhalt der Krankmeldung" [toggleable]="true">
    <div [innerHTML]="absencePrefill.emailContent"></div>
  </p-panel>
}
@if (activityLoading) {
  <app-dialog-skeleton />
} @else {
  <form [formGroup]="absenceForm" (ngSubmit)="absenceDialogSubmit()">
    <!-- Abwesenheitsart -->
    <div
      class="form-group required-field"
      [ngClass]="{
        'p-invalid':
          absenceForm.get('absenceType')?.invalid &&
          (absenceForm.get('absenceType')?.touched ||
            absenceForm.get('absenceType')?.dirty),
      }"
    >
      <p-floatLabel variante="in">
        <p-dropdown
          id="absenceType"
          [options]="absenceTypes"
          formControlName="absenceType"
          name="absenceType"
        ></p-dropdown>
        <label for="absenceType">Art der Abwesenheit*</label>
      </p-floatLabel>
    </div>

    <!-- Von -->
    <div
      class="form-group small-calendar required-field"
      [ngClass]="{
        'p-invalid':
          absenceForm.get('startDate')?.invalid &&
          (absenceForm.get('startDate')?.touched ||
            absenceForm.get('startDate')?.dirty),
      }"
    >
      <p-floatLabel variante="in">
        <p-calendar
          id="startDate"
          formControlName="startDate"
          name="startDate"
          [showIcon]="true"
          dateFormat="dd.mm.yy"
          appendTo="body"
          (onSelect)="onStartDateChanged($event)"
        ></p-calendar>
        <label for="startDate">Startdatum*</label>
      </p-floatLabel>
    </div>

    <!-- Bis -->
    <div
      class="form-group small-calendar required-field"
      [ngClass]="{
        'p-invalid':
          absenceForm.get('endDate')?.invalid &&
          (absenceForm.get('endDate')?.touched ||
            absenceForm.get('endDate')?.dirty),
      }"
    >
      <p-floatLabel variante="in">
        <p-calendar
          id="endDate"
          formControlName="endDate"
          name="endDate"
          [showIcon]="true"
          dateFormat="dd.mm.yy"
          appendTo="body"
        ></p-calendar>
        <label for="endDate">Enddatum*</label>
      </p-floatLabel>
    </div>

    <div class="form-group">
      <p-floatLabel variante="in">
        <p-dropdown
          [options]="courses"
          formControlName="courseId"
          name="selectedCourseId"
          id="selectedCourseId"
          optionLabel="courseName"
          optionValue="courseId"
          [filter]="true"
          filterBy="courseName"
          appendTo="body"
          [showClear]="true"
          scrollHeight="500px"
        ></p-dropdown>
        <label for="selectedCourseId">Kurs</label>
      </p-floatLabel>
    </div>

    <div
      class="form-group required-field"
      [ngClass]="{
        'p-invalid':
          absenceForm.get('participantId')?.invalid &&
          (absenceForm.get('participantId')?.touched ||
            absenceForm.get('participantId')?.dirty),
      }"
    >
      <p-floatLabel variante="in">
        <p-dropdown
          [options]="participants"
          [loading]="usersLoading"
          formControlName="participantId"
          optionLabel="fullName"
          optionValue="userId"
          name="selectedParticipantId"
          id="selectedParticipantId"
          [filter]="true"
          filterBy="fullName"
          [showClear]="true"
          appendTo="body"
          (onChange)="onUserSelected($event)"
        ></p-dropdown>

        <label>
          {{
            absenceForm.get("courseId")?.value === -1
              ? "Interessent:in*"
              : "Teilnehmer:in*"
          }}
        </label>

        <p
          *ngIf="
            absenceForm.get('courseId')?.value !== null &&
            participants.length === 0
          "
          style="margin-top: 5px; color: red; font-style: italic"
        >
          {{
            absenceForm.get("courseId")?.value === -1
              ? "Keine Interessent:innen gefunden."
              : "Keine Teilnehmer für diesen Kurs gefunden."
          }}
        </p>
      </p-floatLabel>
    </div>
    <div>
      <app-filedrop
        bucketname="absences"
        [oldFiles]="oldFiles"
        (fileUploadStarted)="onUploadStart()"
        (fileUploadCompleted)="onUploadDone($event)"
      >
      </app-filedrop>
    </div>
    <p>(* Pflichtfelder)</p>

    <div class="form-buttons">
      <button
        pButton
        [loading]="isSubmitting"
        label="Speichern"
        title="Speichern"
        icon="pi pi-save"
        type="submit"
        class="p-button-success"
        [disabled]="!absenceForm.valid"
      ></button>
      <button
        pButton
        title="Abbrechen"
        type="button"
        label="Abbrechen"
        icon="pi pi-times"
        class="p-button-secondary"
        (click)="closeDialog()"
      ></button>
    </div>
  </form>
}
